import { type JSX } from "react";
import { Body, H2 } from "../Typography"
import { PledgeContainer, PledgeWrapper, PledgeAvatar, PledgeOffset } from "./MarketingUserPledge.styles"

type MarketingUserPledgeProps = {
    profilePledge?: boolean,
    title: JSX.Element,
    description: JSX.Element,
    profilePledgeImage?: string,
    avatarImage: string,
    skipBackground?: boolean
}

export const MarketingUserPledge = ({ profilePledge = false, title, description, profilePledgeImage, avatarImage, skipBackground = false }: MarketingUserPledgeProps) => {
    return <PledgeOffset hasDesktopImg={profilePledge}>
        <PledgeWrapper hasDesktopImg={profilePledge} skipBackground={skipBackground}>
            <PledgeContainer hasDesktopImg={profilePledge}>
                <div>
                    <H2>{title}</H2>
                    <Body>
                        {description}
                    </Body>
                    <PledgeAvatar hasDesktopImg={profilePledge}>
                        <img src={avatarImage} />
                    </PledgeAvatar>
                </div>
                {profilePledge && <div>
                    <img src={profilePledgeImage} />
                </div>}
            </PledgeContainer>
        </PledgeWrapper>
    </PledgeOffset>
}